import type { ChangeEvent } from 'react';
import { handleKeyPress, handlePaste } from './DateInputField/utils';

interface GradeInputColumnProps {
  testId?: string;
  value?: string; // A string of dd
  disabled?: boolean;
  label?: string;
  anchorId?: string;
  onChange?(value: string): void;
}

export default function ExceptionBreakdownColumn({
  testId,
  value = '',
  disabled = false,
  label,
  anchorId,
  onChange,
}: GradeInputColumnProps) {
  const LENGTH = 4;

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (onChange && event.target.value.length <= LENGTH) {
      onChange(`${event.target.value}`);
    }
  };

  return (
    <div className="govuk-date-input__item">
      <div className="govuk-form-group">
        <label className="govuk-label govuk-date-input__label" htmlFor={anchorId}>
          {label}
        </label>
        <input
          className="govuk-input govuk-date-input__input govuk-input--width-3"
          id={anchorId}
          data-testid={testId}
          type="number"
          size={LENGTH}
          value={value}
          onChange={handleChange}
          disabled={disabled ?? false}
          onKeyDown={(e) => handleKeyPress(e)}
          onPaste={(e) => handlePaste(e)}
          onFocus={(e) =>
            e.target.addEventListener('wheel', (e) => e.preventDefault(), { passive: false })
          }
          style={{ width: '200%', backgroundColor: disabled ? '#b1b4b6' : 'transparent' }}
        />
      </div>
    </div>
  );
}
